module.exports = __webpack_public_path__ + "static/media/profile-my-wishlist-red.fa60101f.svg";